import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "../../../shared/api/base-query";
import { pagedQueryFn } from "../../../shared/api/paged-query-fn";
import type { QuerySubscriptionOptions } from "../../../shared/api/query-subscription-options";
import type { IWeedDto } from "../shared";
import { Weed } from "../shared/models/weeds";

export const weedsApiSlice = createApi({
  reducerPath: "api-weeds",
  // https://github.com/reduxjs/redux-toolkit/discussions/2347#discussioncomment-2978038
  refetchOnFocus: false,
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  baseQuery,
  tagTypes: ["WeedsList"],
  endpoints: (builder) => ({
    fetchWeeds: builder.query<Weed[], void>({
      queryFn: pagedQueryFn<IWeedDto, Weed[]>({ url: "WeedsV2" }, (dtos) => {
        const models: Weed[] = dtos.map((dto) => {
          const model = new Weed(dto.id);
          model.updateFromDto(dto);
          return model;
        });
        models.sort((a: Weed, b: Weed) => a.name.localeCompare(b.name));
        return models;
      }),
      providesTags: ["WeedsList"],
    }),
  }),
});

const useWeedsEndpoint = weedsApiSlice.endpoints.fetchWeeds.useQuery;

export function useFetchWeeds(
  options?: QuerySubscriptionOptions<typeof useWeedsEndpoint>
) {
  return useWeedsEndpoint(undefined, options);
}
